































































import { Component, Vue, Watch } from 'vue-property-decorator'
import TopicApi from '@/api/shopMall/topic/index'
@Component
export default class TopicList extends Vue {
  columns = [
    {
      title: '标题',
      key: 'title'
    },
    {
      title: '排序',
      key: 'displayOrder'
    },
    {
      title: '包含在页脚里（列1）',
      key: 'includeInFooterColumn1',
      slot: 'includeInFooterColumn1'
    },
    {
      title: '包含在页脚里（列2）',
      key: 'includeInFooterColumn2',
      slot: 'includeInFooterColumn2'
    },
    {
      title: '包含在页脚里（列3）',
      key: 'includeInFooterColumn3',
      slot: 'includeInFooterColumn3'
    },
    {
      title: '是否发布',
      key: 'published',
      slot: 'published'
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action'
    }
  ]
  data = []
  created() {
    this.loadData()
  }
  loadData() {
    TopicApi.getList(100, 1).then(res => {
      this.data = res.data.items
    })
  }
  removeItem(id) {
    TopicApi.deleteItem(id).then(res => {
      this.$Message.success('删除成功')
      this.loadData()
    })
  }
}
